import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=6b895484&scoped=true"
import script from "./confirmModal.vue?vue&type=script&lang=js"
export * from "./confirmModal.vue?vue&type=script&lang=js"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=6b895484&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b895484",
  null
  
)

export default component.exports